import React from "react";
import { Link } from "react-router-dom";
import { Heart, Truck, Shield, Users } from "lucide-react";

const About = () => (
  <div data-testid="about-page">
    <section className="border-b border-border bg-muted">
      <div className="container-wide py-16 lg:py-20">
        <p className="kicker">About Fast Junk Pros</p>
        <h1 className="mt-3 font-display text-4xl font-black sm:text-5xl lg:text-6xl">
          Local hauling done <br /> the honest way.
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
          Fast Junk Pros is a locally owned trash hauling and junk removal service. We show up, we do the work, we
          charge what we quoted — and we treat every home like it&apos;s our neighbor&apos;s.
        </p>
      </div>
    </section>

    <section className="section">
      <div className="container-wide grid gap-12 lg:grid-cols-2">
        <div>
          <h2 className="font-display text-3xl font-black sm:text-4xl">Our promise</h2>
          <p className="mt-4 text-muted-foreground">
            You call us, we call you back the same day. You get a firm price before anyone shows up. Our crew comes
            out, hauls everything away, and disposes of it the right way. That&apos;s it. No hidden fees, no
            upsells, no runaround.
          </p>
          <p className="mt-4 text-muted-foreground">
            We keep our operation small and personal on purpose — so you always feel like you&apos;re talking to a
            real person who cares about doing the job right.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-4">
            {[
              { icon: Heart, t: "Locally Owned", d: "Small, personal team" },
              { icon: Truck, t: "Fully Equipped", d: "Trucks & trailers ready" },
              { icon: Shield, t: "Upfront Pricing", d: "Quoted before we roll" },
              { icon: Users, t: "Real People", d: "Not a call center" },
            ].map((v) => (
              <div key={v.t} className="rounded-sm border border-border bg-card p-5">
                <v.icon className="h-5 w-5 text-primary" />
                <p className="mt-3 font-display font-bold">{v.t}</p>
                <p className="text-sm text-muted-foreground">{v.d}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-sm border border-border bg-[hsl(60,6%,11%)] p-8 text-white">
          <p className="kicker text-primary">What we do</p>
          <h3 className="mt-3 font-display text-2xl font-bold">
            One call. Every kind of junk gone.
          </h3>
          <p className="mt-4 text-white/70">
            Household junk, yard debris, construction debris, bulk items, appliances, eviction cleanouts, storm
            cleanup, and dumpster rentals — we do it all, every day.
          </p>
          <Link to="/contact" className="btn-cta mt-6" data-testid="about-cta">
            Book a Pickup
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default About;
